import loadable from '@wix/yoshi-flow-editor/loadable';

export default loadable(() => import(/* webpackChunkName: "badge-lib" */ '../badge'));
